import { render, staticRenderFns } from "./out.vue?vue&type=template&id=12132c04&scoped=true&"
import script from "./out.vue?vue&type=script&lang=js&"
export * from "./out.vue?vue&type=script&lang=js&"
import style0 from "./out.vue?vue&type=style&index=0&id=12132c04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12132c04",
  null
  
)

export default component.exports